module.exports = __webpack_public_path__ + "img/messages-bubble-square-text.92ba2dc6.svg";